import React from 'react';
import WaveLoader from './WaveLoader';

// `cardStyle`/`bodyStyle` are optional escape hatches for a caller that needs to
// override the card's box layout (e.g. centering content vertically when a grid
// stretches this panel taller than its content) without changing the shared
// .card/.card-body CSS used by every other Panel on the site.
function Panel({ title, subtitle, loading, children, cardStyle, bodyStyle, actions }) {
  return (
    <div className="card" style={cardStyle}>
      <div className="card-header" style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '12px' }}>
        <div><span style={{ fontWeight: 700, color: 'var(--text-dark)', textTransform: 'uppercase', letterSpacing: '0.12em' }}>{title}</span>
        {subtitle && <span style={{ display:'block', fontSize: '12px', color: 'var(--text-light)', fontWeight: 400 }}>{subtitle}</span>}</div>{actions}
      </div>
      <div className="card-body" style={bodyStyle}>
        {loading ? <WaveLoader /> : children}
      </div>
    </div>
  );
}

export default Panel;
